import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
} from "@angular/core";

/**
 * Generated class for the GridPropertiesDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: "[grid-properties]",
})
export class GridPropertiesDirective implements OnInit, AfterViewInit {
  @Input("grid-properties") properties: object;

  constructor(public renderer: Renderer2, public elementRef: ElementRef) {
    // console.log('Hello GridPropertiesDirective Directive');
  }

  ngOnInit(): void {
    // console.log( "Adding grid property directive instance: ", this );
  }

  ngAfterViewInit(): void {
    let props = this.properties;
    if (props) {
      let propertyKeys = Object.keys(props);
      if (propertyKeys.length != 0) {
        for (let key of propertyKeys) {
          this.renderer.setAttribute(
            this.elementRef.nativeElement,
            key,
            props[key]
          );
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/grid-properties/grid-properties.ts